import Highcharts from 'highcharts';
import { useIntl } from 'react-intl';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

import Paper from 'components/paper';

import getLineGraphOptions from 'utils/get-line-graph-options';
import { WeightPerWeekSeries } from 'views/bluviu-nutrition/features/scenarios-v2/utils/build-weight-per-week-series';

interface WeightPerWeekProps {
  series: WeightPerWeekSeries[];
}

const PAGE_NAME_ID = 'bluViuNutritionR2.results.graph';

const WeightPerWeekGraph: React.FC<WeightPerWeekProps> = ({ series }) => {
  const intl = useIntl();

  return (
    <Paper marginTop={0}>
      <HighchartsReact
        highcharts={Highcharts}
        options={
          {
            ...getLineGraphOptions({
              xAxisTitle: intl.formatMessage({ id: `${PAGE_NAME_ID}.weeks` }),
              yAxisTitle: intl.formatMessage({ id: `${PAGE_NAME_ID}.weight` }),
              formatNumber: intl.formatNumber,
            }),
            tooltip: {
              shared: true,
              style: { fontSize: '12px' },
              headerFormat: '<span style="font-size:14px">Week: {point.key}</span><br/>',
            },

            series: series as Highcharts.SeriesOptionsType[],
          } as Highcharts.Options
        }
      />
    </Paper>
  );
};

export default React.memo(WeightPerWeekGraph);
